import axios from 'axios';
import getHeaders from '../../constants/headers';
import { STORE_BASE_URL } from '../BaseURL';

export const storeBulkProcessingPayment = (storeId, data) => {
  return axios({
    method: 'post',
    url:
    STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/bulk-payment',
    headers:  getHeaders(),
    data: JSON.stringify(data),
  });
};

export const closeOrder = (brandId, storeId, data) => {
  return axios({
    method: 'post',
    url:
    STORE_BASE_URL +
    '/store/api/secure/v1/brand/' +
    brandId +
    '/store/' +
    storeId +
    '/close-order',
    headers:  getHeaders(),
    data: JSON.stringify(data),
  });
};

export const bulkHomeDelivery = (data) => {
  return axios({
    method: 'post',
    url:
    STORE_BASE_URL +
      '/store/api/secure/v1/bulk-home-delivery',
    headers:  getHeaders(),
    data: JSON.stringify(data),
  });
};


// export const closeOrder = async (brandId, storeId, data) => {
//   return axios({
//     method: 'post',
//     url:
//       STORE_BASE_URL +
//       '/store/api/secure/v1/brand/' +
//       brandId +
//       '/store/' +
//       storeId +
//       '/close-order',
//     headers: await getHeaders2(),
//     data: JSON.stringify(data),
//   });
// };




// export const bulkHomeDelivery = async (data) => {
//   return axios({
//     method: 'post',
//     url:
//       STORE_BASE_URL +
//       '/store/api/secure/v1/bulk-home-delivery',
//     headers: await getHeaders2(),
//     data: JSON.stringify(data),
//   });
// };





// curl --location 'store/api/secure/v1/store/1/bulk-payment' \
// --header 'Authorization: Bearer eyJhbGciOiJIUzUxMiJ9.eyJhdXRob3JpdGllcyI6WyJST0xFX1NVUEVSX0FETUlOIl0sImRldmljZVRva2VuIjoiZDQxZDhjZDk4ZjAwYjIwNGU5ODAwOTk4ZWNmODQyN2UiLCJsb2dnZWRJblVzZXJJZCI6Ik9JVDM3NTcyIiwibG9nZ2VkSW5Vc2VyQnJhbmRJZCI6IjEiLCJzdWIiOiIxIiwiaWF0IjoxNzQ2MjY3MTU4LCJleHAiOjE3NDY4NzE5NTh9.QMpP3vq1Ub3PYWT9bem5lhFKVIJ7sgxeEc6CZePOeDeJnp5jSShCaEJJym-FQTeaCQ5U6ABUes5Wf6T4b5WDRg' \
// --header 'Content-Type: application/json' \
// --header 'Cookie: JSESSIONID=9409DB82A4EB5325FEAF169F0AE8B32F' \
// --data '{
//     "orderIds" : [2521, 2516],
//     "paymentMode" : "CASH", 
//     "receivedBy" :"2",
//     "totalPaidAmount" : "1295"
// }'